<template>
  <section>
    <div class="container">
      <b-tabs
        size="is-large"
        class="has-text-weight-bold is-hidden-touch"
        position="is-centered"
        type="is-toggle-rounded"
      >
        <b-tab-item label="Count of Tweets">
          <bar-chart :dataset="showData"></bar-chart>
        </b-tab-item>
        <b-tab-item label="Stressed Tweets">
          <bar-chart :dataset="wordsData"></bar-chart>
        </b-tab-item>
      </b-tabs>
      <b-tabs
        size="is-small"
        class="has-text-weight-bold is-hidden-desktop"
        position="is-centered"
        type="is-toggle-rounded"
      >
        <b-tab-item label="Count of Tweets">
          <bar-chart :dataset="showData"></bar-chart>
        </b-tab-item>
        <b-tab-item label="Stressed Tweets">
          <bar-chart :dataset="wordsData"></bar-chart>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
  import BarChart from "@/components/BarChart";
  export default {
    components: {
      BarChart,
    },
    props: {
      showType: String,
    },
    data() {
      return {
        data: this.$store.state.tweetData,
      };
    },
    computed: {
      filteredData() {
        return this.data.filter((row) => {
          return row.show_type == this.showType;
        });
      },
      showData() {
        return this.filteredData.map((row) => ({
          key: row.show,
          value: row.num_stressed_tweets,
          max: row.max_number,
        }));
      },
      wordsData() {
        let maxValue;
        const totalWordsObj = this.filteredData
          .map((row) => row.stressed_word_counts)
          .flat()
          .reduce((acc, obj) => {
            let key = obj["name"];
            let value = obj["count"];
            if (!acc[key]) {
              acc[key] = {};
              acc[key].value = 0;
              acc[key].max = 0;
            }
            acc[key].key = key;
            acc[key].value = acc[key].value + value;
            acc[key].max = acc[key].max > value ? acc[key].max : value;
            return acc;
          }, {});
        const totalWordsArr = Object.values(totalWordsObj);
        maxValue = totalWordsArr.reduce((prev, curr) =>
          prev > curr.value ? prev : curr.value
        );
        totalWordsArr.forEach((obj) => (obj.max = maxValue));
        return totalWordsArr.sort((a, b) => b.value - a.value).slice(0, 5);
      },
    },
  };
</script>
